import type { OfferReduxBaseState } from '../types/offerReduxBaseState';

export function getLeadCampaignData(state: OfferReduxBaseState) {
    const meta = state?.meta || {};
    return {
        vehicle: meta.vehicle || {},
        campaignData: meta?.additionalData?.campaignData || {}
    };
}
